import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export function useLocale() {
  const { locale } = useI18n()

  const currentLocale = computed(() => locale.value)

  function setLocale(nextLocale: 'uk' | 'ru') {
    locale.value = nextLocale
    localStorage.setItem('unilib_locale', nextLocale)
  }

  return {
    currentLocale,
    setLocale,
  }
}
